import React from "react";
import { InputText } from "primereact/inputtext";
import { Password } from "primereact/password";
import { Button } from "primereact/button";

export default function AdminAccountStep({ formData, updateField, onNext, onBack, toast }) {
  const canProceed =
    formData.adminName.trim() &&
    formData.adminEmail.trim() &&
    formData.adminPassword.length >= 6 &&
    formData.adminPassword === formData.confirmPassword;

  const handleNext = () => {
    if (formData.adminPassword !== formData.confirmPassword) {
      toast.current?.show({
        severity: "warn",
        summary: "Password Mismatch",
        detail: "Passwords do not match",
        life: 3000,
      });
      return;
    }
    if (formData.adminPassword.length < 6) {
      toast.current?.show({
        severity: "warn",
        summary: "Weak Password",
        detail: "Password must be at least 6 characters",
        life: 3000,
      });
      return;
    }
    onNext();
  };

  return (
    <div>
      <div className="step-title">Admin Account</div>

      <div className="p-field">
        <label htmlFor="adminName">Admin Name *</label>
        <InputText
          id="adminName"
          value={formData.adminName}
          onChange={(e) => updateField("adminName", e.target.value)}
          placeholder="John Doe"
        />
      </div>

      <div className="p-field">
        <label htmlFor="adminEmail">Admin Email *</label>
        <InputText
          id="adminEmail"
          type="email"
          value={formData.adminEmail}
          onChange={(e) => updateField("adminEmail", e.target.value)}
          placeholder="admin@school.com"
        />
      </div>

      <div className="formgrid grid">
        <div className="field col-12 md:col-6">
          <label htmlFor="adminPassword">Password *</label>
          <Password
            id="adminPassword"
            value={formData.adminPassword}
            onChange={(e) => updateField("adminPassword", e.target.value)}
            toggleMask
            feedback={false}
          />
        </div>
        <div className="field col-12 md:col-6">
          <label htmlFor="confirmPassword">Confirm Password *</label>
          <Password
            id="confirmPassword"
            value={formData.confirmPassword}
            onChange={(e) => updateField("confirmPassword", e.target.value)}
            toggleMask
            feedback={false}
          />
        </div>
      </div>

      <div className="step-actions">
        <Button
          label="Back"
          icon="pi pi-arrow-left"
          className="p-button-secondary"
          onClick={onBack}
        />
        <Button
          label="Next"
          icon="pi pi-arrow-right"
          iconPos="right"
          onClick={handleNext}
          disabled={!canProceed}
        />
      </div>
    </div>
  );
}
